/* eslint-disable prettier/prettier */
/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
	<Path d="M14.6 7l-1.2-1L8 12l5.4 6 1.2-1-4.6-5z" />
	</SVG>
);
/* eslint-enable */
